/**
 * This file is generated from scripts/genIconComponents.ts. Any
 * changes should be made in that file.
 */
import { color as colorFn } from "@smartsheet/design-tokens-react";
import React, { CSSProperties, forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../components/icon/GeneratedIconProps";
import { Icon } from "../../components/icon/Icon";
import { getUrsaIconColorVarName } from "../../components/icon/getUrsaIconColorVarName";
import ChevronLeftIcon16 from "./ChevronLeftIcon16";
import ChevronLeftIcon20 from "./ChevronLeftIcon20";
import ChevronLeftIcon24 from "./ChevronLeftIcon24";

const getSizeMap = (viewBox?: string, width?: string | number, height?: string | number) => {
    return {
        16: viewBox ? (
            <ChevronLeftIcon16 viewBox={viewBox} width={width ? width : 16} height={height ? height : 16} />
        ) : (
            <ChevronLeftIcon16 width={width ? width : 16} height={height ? height : 16} />
        ),
        20: viewBox ? (
            <ChevronLeftIcon20 viewBox={viewBox} width={width ? width : 20} height={height ? height : 20} />
        ) : (
            <ChevronLeftIcon20 width={width ? width : 20} height={height ? height : 20} />
        ),
        24: viewBox ? (
            <ChevronLeftIcon24 viewBox={viewBox} width={width ? width : 24} height={height ? height : 24} />
        ) : (
            <ChevronLeftIcon24 width={width ? width : 24} height={height ? height : 24} />
        ),
    };
};

export interface ChevronLeftIconProps extends GeneratedIconProps {
    /**
     * The size to render the icon at.
     */
    size: 16 | 20 | 24;
}

export const ChevronLeftIcon = forwardRef(
    (
        {
            // This is the default icon color.
            color = `var(${getUrsaIconColorVarName()}, ${colorFn("color--icons--neutral--strongest")})`,
            size,
            viewBox,
            width,
            height,
            style,

            ...rest
        }: ChevronLeftIconProps,
        ref: Ref<HTMLElement>
    ) => {
        return (
            <Icon
                color={color}
                ref={ref}
                size={size}
                width={width}
                height={height}
                {...rest}
                style={
                    {
                        ...style,
                    } as CSSProperties
                }
            >
                {getSizeMap(viewBox, width, height)[size]}
            </Icon>
        );
    }
);
ChevronLeftIcon.displayName = "ChevronLeftIcon";
